// extracted by mini-css-extract-plugin
export default {"whyUs":"whyUsSection_whyUs__RcpwY","header":"whyUsSection_header__3E6K9","para":"whyUsSection_para__2fMAQ","image":"whyUsSection_image__6SV0h"};